/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import gql from 'graphql-tag';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 * @param {string} partNumber - SKU to be fetched
 */

const findPassportByPartNumber = (brand, partNumber) => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`{ findProductPageByPartNumber(brand: "${brand}", environment: "${GRAPHQL_ENV}", partNumber: "${partNumber}") {
            content
            defaultContent
            product {
                partNumber
                baseCode
                prices {
                    currency
                    type
                    value
                }
            }
        }
    }
`
);

export default findPassportByPartNumber;
